import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromIndirectRateCostCenter from './indirect-rate-cost-center.reducer';

export const selectIndirectRateCostCenterState = createFeatureSelector<
    fromIndirectRateCostCenter.State
>(fromIndirectRateCostCenter.indirectRateCostCentersFeatureKey);

export const {
    selectIds,
    selectEntities,
    selectAll,
    selectTotal
} = fromIndirectRateCostCenter.adapter.getSelectors(
    selectIndirectRateCostCenterState
);
